import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthenticationProvider } from "./Context/Authentication";
import { TokenCallProvider } from "./Context/TokenCall";
import Validation from "./Validation";
import { InventoryProductProvider } from "./Context/Cache/InventoryProductContext";
import { CartInventoryProvider } from "./Context/Cache/CartInventoryContext";
import { IncomingInventoryProvider } from "./Context/Cache/IncomingInventory/IncomingInventoryContext";
import { Search } from "@mui/icons-material";
import { SearchProvider } from "./Context/SetGlobalSearch";
import { AmazonInventoryCacheProvider } from "./Context/Cache/AmazonInventory/AmazonInventoryCacheContext";
import { ReplenishmentInventoryProvider } from "./Context/Cache/Replenishment/ReplenishmentInventoryContext";
import 'react-toastify/dist/ReactToastify.css';
import { RecentOrderProvider } from "./Context/Cache/RecentOrder/RecentOrderContext";
import { QuoteOfferProvider } from "./Context/Cache/QuoteOffers/QuoteOfferContext";
import { RecentOrdersProvider } from "./Context/Cache/RecentOrder/RecentOrdersContext";
import { CartAccountProvider } from "./Context/Cache/CartAccount/CartAccountContext";
import { ToastContainer } from "react-toastify";
import { msalConfig } from "./msalConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
const pca = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* <MsalProvider instance={pca}> */}

      <TokenCallProvider>
        {/* <RecentOrderProvider> */}
        <AuthenticationProvider>
          <RecentOrdersProvider>
            <QuoteOfferProvider>
              <SearchProvider>
                <InventoryProductProvider>
                  <AmazonInventoryCacheProvider>
                    <IncomingInventoryProvider>
                      {/* <ReplenishmentInventoryProvider> */}
                      <CartAccountProvider>
                        <CartInventoryProvider>
                          <ToastContainer />
                          <App />
                        </CartInventoryProvider>
                      </CartAccountProvider>
                      {/* </ReplenishmentInventoryProvider> */}
                    </IncomingInventoryProvider>
                  </AmazonInventoryCacheProvider>
                </InventoryProductProvider>
              </SearchProvider>
              {/* <Validation /> */}
            </QuoteOfferProvider>
          </RecentOrdersProvider>
        </AuthenticationProvider>
        {/* </RecentOrderProvider> */}
      </TokenCallProvider>
    {/* </MsalProvider> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();